module.exports = __webpack_public_path__ + "img/virtual-bg.32b1c967.svg";